import { takeEvery, select } from 'redux-saga/effects'
import { LOCATION_CHANGE } from 'react-router-redux'
import { includes, toString } from 'lodash/fp'

export const getUserUID = (state) => state.player.uid

function* sendLocationChangeToAirtable({ payload }) {
  const pageVisited = payload.pathname.slice(1)
  const userUID = yield select(getUserUID)
  const currentTime = new Date().toISOString()
  const nonRoomPages = ['age', 'player', 'aloha', 'level', 'rules', 'raffle']

  const inRoomPages =
    !includes(toString(pageVisited.match(/[^\/][\w]+/g)), nonRoomPages) &&
    pageVisited.length > 0

  if (userUID && inRoomPages) {
    const requestData = {
      currentTime,
      pageVisited,
      userUID,
    }
    fetch(`${process.env.GATSBY_ENDPOINT}/airtable-save-room-engagement`, {
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
      },
      body: JSON.stringify(requestData),
    })
  }
}

export const AirtableTrackingSagas = [
  takeEvery(LOCATION_CHANGE, sendLocationChangeToAirtable),
]



// WEBPACK FOOTER //
// ./src/sagas/airtableTracking.js